var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_2570)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9315 0.547089H39.9317V40.5361H-0.0572516L-0.0576172 40.5361V13.4954H-0.0572516V0.547089H19.2548H20.6195H39.9315ZM30.2753 14.8599L38.5665 14.8599L38.5665 39.1715L30.2753 39.1715L30.2753 14.8599ZM28.9102 14.8599L28.9102 39.1715H20.619L20.619 14.8599H20.6195L28.9102 14.8599ZM19.2548 1.91162V13.4954H19.2544H10.9633H9.59815H1.30728V1.91162H19.2548ZM30.2753 13.4954H28.9102H20.6195V1.91162H38.567V13.4954L30.2753 13.4954ZM9.59815 14.8599L9.59815 39.1715L1.30728 39.1715V14.8599H9.59815ZM10.9633 14.8599H19.2544L19.2544 39.1715H10.9633L10.9633 14.8599Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_2570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6D);
export default __webpack_public_path__ + "static/media/6d.0aa16145c4c5d10abc113419deebb35f.svg";
export { ForwardRef as ReactComponent };